<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteMediaProduct',
    props: {
        popupDeleteMedia: {
            type: Boolean,
            default: false,
        },
        mediaId: Number
    },

    watch: { 
      	popupDeleteMedia: function(newVal) {
            if(newVal == true){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف ویدئو",
                    text: `ویدئو حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteMedia,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteMedia', false)
        },

        deleteMedia(){
            this.$vs.loading()
            this.$emit('updatePopupDeleteMedia', false)
            let id = this.mediaId
            let type = 'media'
			this.$store.dispatch('deletePost', { id, type })
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'ویدئو با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>